export {default} from './botChatModel';
export * from './botChatModel';



// WEBPACK FOOTER //
// ./src/models/botChatModel/index.ts